<template lang="pug">
  div(v-if="isAssinaturaInserida !== false")
    p {{informacaoAssinatura}}

    div.center
      div(v-for="(img, index) in assinatura" :key="index")
        el-image(
          style='width: 350px; height: 220px'
          :src="img"
          class="h1"
        )
      p {{textoAsssinatura}}
  div(v-else)
    .center
      p {{termoGaleria}}
</template>

<script>
import AppDisplay from '../AppDisplay'

export default {
  components: {
    AppDisplay
  },
  props: {
    assinatura: {
      type: Array,
      required: true
    },
    isAssinaturaInserida: {
      type: Boolean,
      required: false
    }
  },

  data () {
    return {
      isMa: process.env.ESTADO === 'ma',
      informacaoAssinatura: 'Por serem verdadeiras, assumo a inteira responsabilidade pelas informações por mim prestadas neste formulário.',
      textoAsssinatura: 'Assinatura do proprietário',
      termoGaleria: 'O termo assinado está disponivel na aba galeria'
    }
  }
}
</script>
<style scoped>
.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

}

.h1 {
  border-bottom: 1px solid #606266;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/AssinaturaMobile.vue